<template>
  <div class="client">
      <div class="preloader" v-if="preloader">
        <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
      </div>
      <!-- hideClientName - спрятать название клиента в карточке клиента -->
      <a href="#" @click.prevent="goToClientCard()" class="title">{{clientInfo.client.name}}</a>

      <div class="options-block">
          <p><span>Презентация: </span>{{clientInfo.title}}</p>
          <p><span>Дата: </span>{{clientInfo.datePresentation}}</p>

          <div class="edit-block">
              <a v-if="clientInfo.completed != 1" href="#" @click.prevent="editPresent()" class="edit">Редактировать</a>
              <a v-if="clientInfo.completed != 1" href="#" @click.prevent="delPresentation()" class="delete">Удалить</a>
          </div>
      </div>

      <div v-if="(clientInfo.completed != 0)" class="icon-block">
          <a v-if="(clientInfo.isFeedback == 0)" href="#" @click.prevent="goToCommentForm" class="alertIcon"></a>
          <a v-else href="#" class="reSend" @click="sendReport()"></a>
      </div>

      <a v-else  @click="detail(clientInfo.collectionId)"  class="button">Начать презентацию</a>

  </div>
</template>
<script>
export default {
    props: ['clientInfo'],
    data: function(){
        return {
            preloader: false
        }
    },
    methods: {
        /**
         * Начать презентацию
         * id - ID коллекции
         */
        detail(id){
            //Добавить в localStorage информацию о текущем клиенте
            this.$localStorageSet('currentClientInfo', this.clientInfo);
            this.$localStorageSet('presentationStart', true);
            this.$localStorageSet('presentationStartedID', id);
            this.$localStorageSet('presentationID', this.clientInfo.id);
            this.$router.push('/catalog/'+id);
        },
        delPresentation(){
            let obj = {
                presentationID: this.clientInfo.id,
                companyId: this.clientInfo.clientId,
                collectionId: this.clientInfo.collectionId
            }
            this.$store.dispatch('DELETE_PRESENTATION', obj).then(r=>{
                this.$emit('deletePresentationItem', this.clientInfo)
            })
        },
        // Отправить отчет повторно
        sendReport(){
            this.preloader = true
            let data = {
                clientId: this.clientInfo.clientId,
                collectionId: this.clientInfo.collectionId,
                presentationId: this.clientInfo.id,
                email: this.clientInfo.client.email
            }
            this.$store.dispatch('RE_SEND_REPORT', data).then(r=>{
                this.preloader = false;
                this.$makeToast(
                    "Поздравляем!",
                    "success",
                    `Отчет отправлен на ваш e-mail!`
                );
            })
        },
        // Заполнить отчет
        goToCommentForm(){
            this.$localStorageSet('currentClientInfo', this.clientInfo)
            this.$localStorageSet('presentationID', this.clientInfo.id)
            this.$router.push({name: 'comment' })
        },
        // Отредактировать презентацию
        editPresent(){
            this.$router.push('/editPresentation/'+this.clientInfo.id)
        },
        goToClientCard(){
            this.$localStorageSet('clientCardInfo', this.clientInfo.client)
            this.$router.push('/clientCard/'+this.clientInfo.clientId)

        }
    }
}
</script>
<style lang="scss" scoped>
.client{
    width: 100%;
    min-height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    margin-bottom: 20px;
    background: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    
    .title{
        width: 100%;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        text-transform: uppercase;
        margin-bottom: 15px;
    }
    .button{
        width: 100%;
        background: #333333;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #000000;
        font-size: 14px;
        font-weight: 500;
        text-transform: uppercase;
        color: #fff;
    }
    .options-block{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 20px;
        p, span{
            font-weight: 500;
            font-size: 14px;
            text-transform: capitalize;
            color: #000000;
        }
    }
    .icon-block{
        height: 32px;
        display: flex;
        align-items: center;
        
        justify-content: flex-end;
        .reSend,
        .alertIcon{
            width: 32px;
            height: 32px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          
            background-color: #fff;
        }
        .alertIcon{
            background-image: url('../../img/alert.svg');
        }
        .reSend{
            background-image: url('../../img/resend.svg');
        }
    }
    .edit-block{
        width: 100%;
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .edit{
            width: 49%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #11862f;
            color: #fff;

        }
        .delete{
            width: 49%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #a71930;
            color: #fff;
        }
    }
}

</style>